<template>
  <el-container style="min-height: 939px;">
    <el-aside width="200px" style="background-color: #304156; float: left">
      <el-menu router :default-openeds="['0', '1']" style="background-color: #304156;">
        <el-submenu v-for="(item,index) in $router.options.routes" :index="index+''" :key="index" v-if="item.show">
          <template slot="title"><i class="el-icon-menu"></i>{{item.name}}</template>
          <el-menu-item v-for="(item2,index) in item.children" :index="item2.path" :key="index"
                        :class="$route.path===item2.path?'is-active':''" v-if="item2.show">
            {{item2.name}}
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'DataExchange',
  mounted () {
    let loginParams = localStorage.getItem('loginParams')
    if (loginParams) {
      try {
        let result = JSON.parse(loginParams)
        const {username, password} = result
        if (!!username && !!password) {
          if (username === 'sada' && password === 'sada1234') {
            this.$router.push('/PushDest')
          } else {
            this.$router.push('/user/login')
          }
        }
      } catch (error) {
        this.$router.push('/user/login')
      }
    } else {
      this.$router.push('/user/login')
    }
  }
}
</script>

<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .el-aside {
    color: #333;
  }
  .el-submenu__title:hover {
    background-color: rgb(48, 65, 86) !important;
  }
  .el-menu{
    background-color: rgb(48, 65, 86) !important;
    border-right: none !important;
  }
  .el-submenu__title{
    color: #eeeeee !important;
  }
  .el-menu-item{
    color: #eee !important;
  }
  .el-menu-item:focus, .el-menu-item:hover, .el-menu-item:active{
    background-color: #1f2d3d!important;
    color: rgb(24, 144, 255) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/DataExchange.vue